export default __webpack_public_path__ + "static/media/google_play.24873005.png";